import { url } from "@/lib/validation/rules/other.ts";

function useCloudinary(
  path: string,
  options: Src.File.Application.Resources.CloudinaryUrlOptions,
): string {
  if (url().validate(path)) {
    return path;
  }

  const baseUrl = "https://res.cloudinary.com/solvari/image/upload";
  let imageOptions = "dpr_auto,q_auto";

  if (options.pad) {
    imageOptions = `${imageOptions},c_pad`;
  } else {
    imageOptions = `${imageOptions},c_fill`;
  }

  if (!path.endsWith(".svg")) {
    imageOptions = `${imageOptions},f_auto`;
  }
  if (options.radius) {
    imageOptions = `${imageOptions},r_${options.radius}`;
  } else {
    imageOptions = `${imageOptions},g_auto`;
  }
  imageOptions = `${imageOptions},w_${options.width}`;
  if (options.height !== "auto") {
    imageOptions = `${imageOptions},h_${options.height}`;
  }

  return `${baseUrl}/${imageOptions}/${path}`;
}

export { useCloudinary };
